import { gql } from '@apollo/client';

export const GET_CONTRACT = gql`
  query GetContract($id: String!, $expensesFilterInput: ExpensesReportFilterInput) {
    contract(id: $id) {
      id
      createdAt
      startDate
      finishDate
      keysDelivered
      keysReceived
      signed
      leaseTermOption
      rentAmount
      statusOption
      dayForExecuteCharges
      monthlyChargeAmount
      isAutoGenerateRentCharges
      unities {
        id
        name
      }
      property {
        id
        name
        address {
          street
          buildingNumber
          addressLine
          zipCode
          country {
            name
          }
          state {
            name
          }
          city {
            name
          }
        }
      }
      rentCharges {
        id
        amountValue
        rentChargeTypeOption
        rentChargeStatusOption
        executionDate
        description
      }
      tenant {
        firstName
        lastName
        user {
          id
        }
      }
      owner {
        firstName
        lastName
        user {
          id
        }
      }
      notes {
        id
        text
        createdAt
        ownerFirstName
        ownerLastName
      }
      incidents {
        id
        subject
        incidentTypeOption
        incidentCategoryOption
        priorityOption
        statusOption
        startDate
        endDate
        unity {
          name
        }
      }
    }
    expensesReport(filterInput: $expensesFilterInput) {
      items {
        id
        incidentId
        contractId
        incidentSubject
        propertyName
        supplierName
        payerLabel
        payerUserType
        paidToSupplier
        collectedFromPayer
        title
        description
        date
        expenseCost
        invoiceNumber
        chargeStatus
        typeOption
        currencyOption
      }
      pagination {
        totalItems
        totalPages
        currentPage
        pageSize
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;
